import { SpaPackageListingType } from 'shared-types/SpaPackage';

export const sortUnavailableLast = <
  T extends Pick<SpaPackageListingType, 'unAvailable' | 'displayOrder'>
>(
  items: T[]
): T[] =>
  items
    .slice()
    .sort(
      (a, b) => Number(!!a.unAvailable) - Number(!!b.unAvailable) || a.displayOrder - b.displayOrder
    );
